// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__11B8w","title":"ClientInsurance_title__Cfdk9","itemText":"ClientInsurance_itemText__3O25K"};